module.exports = __webpack_public_path__ + "img/clock-eight.ca8608a2.svg";